import PropTypes from 'prop-types';
import styled from 'styled-components';

import sentimentIconSrc from 'components/ui/svg/sentiment.svg';

import commonPropTypes from 'utils/commonPropTypes';

import * as svars from 'assets/style/variables';

const Svg = styled.svg`
  display: inline-block;
  vertical-align: middle;
  min-width: 1.26rem;
`;

function SentimentIconSvg({ iconSize, style }) {
  return (
    <Svg width={iconSize} height={iconSize} viewBox="0 0 50 50" style={style}>
      <circle
        cx="15"
        cy="35"
        r="14"
        fill={svars.absoluteMinColor}
        stroke={svars.colorWhiteLightlyTransparent}
        strokeWidth="2"
      />
      <circle
        cx="35"
        cy="35"
        r="14"
        fill={svars.absoluteMidColorStroke}
        stroke={svars.colorWhiteLightlyTransparent}
        strokeWidth="2"
      />
      <circle
        cx="25"
        cy="15"
        r="14"
        fill={svars.absoluteMaxColor}
        stroke={svars.colorWhiteLightlyTransparent}
        strokeWidth="2"
      />
    </Svg>
  );
}

SentimentIconSvg.propTypes = {
  iconSize: PropTypes.string,
  style: commonPropTypes.style,
};

SentimentIconSvg.defaultProps = {
  iconSize: svars.fontSizeBase,
  style: {},
};

export function SentimentIconSvg2({ iconSize, style }) {
  return (
    <img
      src={sentimentIconSrc}
      alt="No logo"
      style={{ ...style, width: iconSize, height: iconSize }}
    />
  );
}

SentimentIconSvg2.propTypes = SentimentIconSvg.propTypes;
SentimentIconSvg2.defaultProps = SentimentIconSvg.defaultProps;

export default SentimentIconSvg;
